import styled from 'styled-components';
import { arrayOf, shape, string, func } from 'prop-types';

import CircleIcon from '../shared/CircleIcon';
import StyledText from '../shared/StyledText';
import getIconByCategoryId from '../../lib/getIconByCategoryId';
import { GREY_COLOR, SMALL_TEXT, DESKTOP_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.div`
  @media (min-width: ${DESKTOP_SIZE}) {
    display: flex;
  }
`;

const TitleContainer = styled.div`
  margin: 25px 0 0 0;
  @media (max-width: ${DESKTOP_SIZE}) {
    margin: 25px 0 25px 0;
  }
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: grid;
  row-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
`;

const CategoryFilter = ({
  updateCategory,
  categories,
  selectedCategories,
  t,
}) => (
  <Container>
    <TitleContainer>
      <StyledText size={SMALL_TEXT} isBold>
        {t('COMPONENTS_GAMES_FILTER_CATEGORIES_TITLE')}
      </StyledText>
    </TitleContainer>
    <ButtonsContainer>
      {categories.map(({ id, name }, key) => (
        <CircleIcon
          key={key}
          icon={getIconByCategoryId(id)}
          label={name}
          isSelected={selectedCategories.includes(id)}
          onClick={() => updateCategory(id)}
          color={GREY_COLOR}
          size="lg"
          hasHover
        />
      ))}
    </ButtonsContainer>
  </Container>
);

CategoryFilter.propTypes = {
  categories: arrayOf(
    shape({
      name: string.isRequired,
      id: string.isRequired,
    }).isRequired
  ),
  selectedCategories: arrayOf(string.isRequired),
  updateCategory: func.isRequired,
};

export default withI18next()(CategoryFilter);



// WEBPACK FOOTER //
// components/GamesFilter/CategoryFilter.js